import { ROUTE_PATH as PERSONNEL_PATH } from '@/features/personnelPage/consts';

export const FEATURE_NAME = 'personnelEditPage';

export const ROUTE_PATH = `${PERSONNEL_PATH}/:personalityId/edit`;
